import { meta as CMSRedirects } from 'modules/cms-redirects/__meta__';
import { meta as CMSRedirectsDetails } from 'modules/cms-redirects/details/__meta__';
import { meta as AddressPicker } from 'modules/address-picker/meta';
import { meta as CMSPageCustomFields } from 'modules/cms-page-custom-fields/meta';
import { meta as SocialNetworksPreviewer } from 'modules/social-networks-previewer/meta';
import { meta as CMSTags } from 'modules/cmstags/__meta__';
import { meta as CMSTagsDetails } from 'modules/cmstags/details/__meta__';
// import { meta as TenantKeys } from 'modules/tenant-keys/__meta__';
import { meta as TenantKeysDetails } from 'modules/tenant-keys/details/__meta__';
import { meta as Cmspagessections } from 'modules/cmspagessections/__meta__';
import { meta as CmspagessectionsDetails } from 'modules/cmspagessections/details/__meta__';
import { meta as CMSPAGESCATEGORIES } from '@/modules/cmspagescategories/__meta__';
import { meta as CMSPAGESCATEGORIESDetails } from '@/modules/cmspagescategories/details/__meta__';
import { meta as CMSPAGES } from 'modules/cmspages/__meta__';
import { meta as CMSPAGESDetails } from 'modules/cmspages/details/__meta__';
// import { meta as ExternalModuleViewer } from 'modules/external-module-viewer/meta';
import { meta as CMSMenus } from 'modules/cmsmenus/__meta__';
import { meta as CMSMenusDetails } from 'modules/cmsmenus/details/__meta__';
import { meta as CMSCampaigns } from 'modules/cmscampaigns/__meta__';
import { meta as CMSCampaignsDetails } from 'modules/cmscampaigns/details/__meta__';
import { meta as CodeEditor } from 'modules/code-editor/meta';
import { meta as CMSIntegrations } from 'modules/cms-integrations/meta';
import { meta as CMSSettings } from 'modules/cms-settings/__meta__';
import { meta as CMSSettingsDetails } from 'modules/cms-settings/details/__meta__';
import { meta as Drives } from 'modules/drives/__meta__';
import { meta as DrivesDetails } from 'modules/drives/details/__meta__';
import { meta as CMSPageEditor } from 'modules/cmspageeditor/meta';
import { meta as CMS } from 'modules/cms/meta';
import { meta as DataStructuresMapViewer } from 'modules/datastructures-map-viewer/meta';
import { meta as DSCrudModules } from 'modules/dscrudmodules/__meta__';
import { meta as DSCrudModulesDetails } from 'modules/dscrudmodules/details/__meta__';
// import { meta as Modules } from '@/modules/DELETE---modules/__meta__';
import { meta as InteractiveDataStructure } from 'modules/interactive-data-structure/meta';
import { meta as ManageDataGroups } from 'modules/manage-data-groups/meta';
import { meta as DataStructures } from 'modules/data-structures/__meta__';
import { meta as DataStructuresDetails } from 'modules/data-structures/details/__meta__';
import { meta as Tenants } from 'modules/tenants/__meta__';
import { meta as TenantsDetails } from 'modules/tenants/details/__meta__';
import { meta as Products } from 'modules/products/__meta__';
import { meta as ProductsDetails } from 'modules/products/details/__meta__';
import { meta as OrgTierChange } from 'modules/org-tier-change/meta';
import { meta as Orgs } from 'modules/orgs/__meta__';
import { meta as OrgsDetails } from 'modules/orgs/details/__meta__';
import { meta as Scopes } from 'modules/scopes/meta';
import { meta as demos } from 'modules/demos/__meta__';
import { meta as demosDetails } from 'modules/demos/details/__meta__';
import { meta as Welcome } from '@/modules/welcome/__meta__';
import { meta as Sample } from 'modules/__sample/meta';
import { meta as WindowManager } from 'modules/window-manager/meta';
import { meta as Calculator } from 'modules/calculator/meta';
import { meta as Calendar } from 'modules/calendar/meta';
import { meta as about } from 'modules/about/meta';
import { meta as DynamicModule } from 'modules/dynamic-module/meta';
import { meta as FilePicker } from 'modules/file-picker/meta';
// import { meta as Media } from 'modules/media/__meta__';
// import { meta as MediaDetails } from 'modules/media/details/__meta__';
import { meta as Help } from 'modules/help/meta';
import { meta as QuickNote } from 'modules/quick-note/meta';
import { meta as settings } from 'modules/settings/meta';
import { meta as Template } from 'modules/template/meta';

const modules = {
  available: {
    // !IMPORTANT! Dynamic content ahead
    CMSRedirects        : { fileName: `cms-redirects`, ...CMSRedirects},
    CMSRedirectsDetails : { fileName: `cms-redirects/details`, ...CMSRedirectsDetails},
    AddressPicker: { fileName: 'address-picker', ...AddressPicker},
    CMSPageCustomFields: { fileName: 'cms-page-custom-fields', ...CMSPageCustomFields},
    SocialNetworksPreviewer: { fileName: 'social-networks-previewer', ...SocialNetworksPreviewer},
    CMSTags             : { fileName: `cmstags`, ...CMSTags},
    CMSTagsDetails      : { fileName: `cmstags/details`, ...CMSTagsDetails},
    // TenantKeys          : { fileName: `tenant-keys`, ...TenantKeys},
    TenantKeysDetails   : { fileName: `tenant-keys/details`, ...TenantKeysDetails},
    Cmspagessections    : { fileName: `cmspagessections`, ...Cmspagessections},
    CmspagessectionsDetails: { fileName: `cmspagessections/details`, ...CmspagessectionsDetails},
    CMSPAGESCATEGORIES  : { fileName: `cmspagescategories`, ...CMSPAGESCATEGORIES},
    CMSPAGESCATEGORIESDetails: { fileName: `cmspagescategories/details`, ...CMSPAGESCATEGORIESDetails},
    CMSPAGES            : { fileName: `cmspages`, ...CMSPAGES},
    CMSPAGESDetails     : { fileName: `cmspages/details`, ...CMSPAGESDetails},
    // ExternalModuleViewer: { fileName: 'external-module-viewer', ...ExternalModuleViewer},
    CMSMenus            : { fileName: `cmsmenus`, ...CMSMenus},
    CMSMenusDetails     : { fileName: `cmsmenus/details`, ...CMSMenusDetails},
    CMSCampaigns        : { fileName: `cmscampaigns`, ...CMSCampaigns},
    CMSCampaignsDetails : { fileName: `cmscampaigns/details`, ...CMSCampaignsDetails},
    CodeEditor: { fileName: 'code-editor', ...CodeEditor},
    CMSIntegrations: { fileName: 'cms-integrations', ...CMSIntegrations},
    CMSSettings         : { fileName: `cms-settings`, ...CMSSettings},
    CMSSettingsDetails  : { fileName: `cms-settings/details`, ...CMSSettingsDetails},
    Drives              : { fileName: `drives`, ...Drives},
    DrivesDetails       : { fileName: `drives/details`, ...DrivesDetails},
    CMSPageEditor: { fileName: 'cmspageeditor', ...CMSPageEditor},
    CMS: { fileName: 'cms', ...CMS},
    DataStructuresMapViewer: { fileName: 'datastructures-map-viewer', ...DataStructuresMapViewer},
    DSCrudModules       : { fileName: `dscrudmodules`, ...DSCrudModules},
    DSCrudModulesDetails: { fileName: `dscrudmodules/details`, ...DSCrudModulesDetails},
    InteractiveDataStructure: { fileName: 'interactive-data-structure', ...InteractiveDataStructure},
    ManageDataGroups: { fileName: 'manage-data-groups', ...ManageDataGroups},
    DataStructures      : { fileName: `data-structures`, ...DataStructures},
    DataStructuresDetails: { fileName: `data-structures/details`, ...DataStructuresDetails},
    Tenants             : { fileName: `tenants`, ...Tenants},
    TenantsDetails      : { fileName: `tenants/details`, ...TenantsDetails},
    Products            : { fileName: `products`, ...Products},
    ProductsDetails     : { fileName: `products/details`, ...ProductsDetails},
    OrgTierChange: { fileName: 'org-tier-change', ...OrgTierChange},
    Orgs                      : { fileName: `orgs`, ...Orgs},
    OrgsDetails               : { fileName: `orgs/details`, ...OrgsDetails},
    Scopes                    : { fileName: 'scopes', ...Scopes},
    Demos                     : { fileName: `demos`, ...demos},
    DemosDetails              : { fileName: `demos/details`, ...demosDetails},
    Welcome                   : { fileName: 'welcome', ...Welcome},
    Sample                    : { fileName: '__sample', ...Sample},
    WindowManager             : { fileName: 'window-manager', ...WindowManager},
    About                     : { fileName: 'about', ...about},
    Calculator                : { fileName: 'calculator', ...Calculator},
    Calendar                  : { fileName: 'calendar', ...Calendar},
    DynamicModule             : { fileName: 'dynamic-module', ...DynamicModule},
    FilePicker                : { fileName: 'file-picker', ...FilePicker},
    // Media                     : { fileName: `media`, ...Media},
    // MediaDetails              : { fileName: `media/details`, ...MediaDetails},
    Help                      : { fileName: 'help', ...Help},
    QuickNote                 : { fileName: 'quick-note', ...QuickNote},
    Settings                  : { fileName: 'settings', ...settings},
    Template                  : { fileName: 'template', ...Template},
    // Modules: { fileName: 'modules', ...Modules},
  }
};

export default modules;
